module.exports = {
  get: {
    key: 'get',
    label: 'Get',
  },
  put: {
    key: 'put',
    label: 'Put',
  },
  delete: {
    key: 'delete',
    label: 'Delete',
  },
  post: {
    key: 'post',
    label: 'Post',
  },
};